import apiClient from '@/api/apiClient.js';
import apiClient2 from '@/api/apiClient.js';

export default {
  namespaced: true,
  state: {
    schema: {},
    coResults: {},
    overlayCal: false,
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    coResults(state) {
      return state.coResults;
    },
    overlayCal(state) {
      return state.overlayCal;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertResults(state, coResults) {
      state.coResults = coResults;
    },
    insertOverlayCal(state, payload) {
      state.overlayCal = payload;
    },
  },

  actions: {
    async loadSchema({ commit, rootState }) {
      try {
        const res = await apiClient.testCOxResultsSchema();
        const schema = res.data;

        const { hcpNum, coEvaNum, coNum } = rootState.auth.authData;
        const coNameNum = coNum < 10 ? `0${coNum}` : `${coNum}`;

        schema.coInfoResult = {
          name: `HCP-${hcpNum}_Co${coNameNum}-${coEvaNum}.xlsx`,
        };

        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async coResultDownload({ dispatch, rootState }) {
      dispatch('toggleOverlayCal', true);
      try {
        const { hcpNum, coEvaNum, coNum, coNumId: id } = rootState.auth.authData;
        const coNameNum = coNum < 10 ? `0${coNum}` : `${coNum}`;

        const coResults = await apiClient2[`testCOx${coNameNum}xResults`](id);

        const downloadUrl = window.URL.createObjectURL(new Blob([coResults.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `HCP-${hcpNum}_Co${coNameNum}-${coEvaNum}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      } finally {
        dispatch('toggleOverlayCal', false);
      }
    },

    toggleOverlayCal({ commit }, payload) {
      commit('insertOverlayCal', payload);
    }
  },
};
